<template>
	<div class="rb-alert py-3 px-5" data-augmented-ui="both tl-clip br-clip-x">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'RbAlert',
		data: () => ({}),
	}
</script>

<style lang="scss" scoped>
	.rb-alert {
		background: rgba($highlight, .1);
		text-shadow: 0 0 5px rgba($primary, .5);
	}
</style>
